import { useGlobalState } from '../hooks';
import { defaultRender, none } from '../utils';
export const PortalRenderer = ({ id }) => {
    const children = useGlobalState((m) => m.portals[id]) || none;
    return defaultRender(children);
};
//# sourceMappingURL=PortalRenderer.js.map